import React from 'react';
import cn from 'classnames';
import './radio-button.scss';

interface IRadioButton {
  label: string;
  value?: string;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
}

export default function RadioButton({
  label,
  value,
  checked,
  onChange,
  className,
  disabled = false,
}: IRadioButton) {
  return (
    <div className={`radio-button ${className ? className : ''}`}>
      <input
        checked={checked}
        onChange={disabled ? undefined : onChange}
        className={cn(
          'radio-button__input',
          disabled && 'radio-button__input_disabled'
        )}
        type="radio"
        value={value || label}
      />
      <div
        className={cn(
          'radio-button__checkmark',
          disabled && 'radio-button__checkmark_disabled'
        )}
      ></div>
      <label
        className={cn(
          'radio-button__label',
          disabled && 'radio-button__label_disabled'
        )}
      >
        {label}
      </label>
    </div>
  );
}
